import {
  FeasibilityCriterion,
  FeasibilityQuota,
  QUALIFICATION_CODE,
} from '@ps/survey-utils';
import { Option, some } from '@sapphire/result';

export function formatFeasibilityQuotaLabel(
  row: FeasibilityQuota,
  currency: string,
): string {
  return (row.criteria ?? [])
    .map((criterion) => formatFeasibilityCondition(criterion, currency))
    .filter(Boolean)
    .join(',');
}

export function formatFeasibilityCondition(
  criterion: FeasibilityCriterion,
  currency: string,
): string {
  if (
    criterion.qualificationCode === QUALIFICATION_CODE.ZIPCODE &&
    criterion.conditionCodes
  ) {
    return `${criterion.conditionCodes.length} codes uploaded`;
  }

  // Length, not presence: range criteria carry empty arrays and label from rangeSets.
  if (criterion.conditionNames?.length) {
    return criterion.conditionNames.join(', ');
  }

  return Option.from(criterion.rangeSets?.[0])
    .mapInto((range) =>
      some(
        criterion.qualificationCode === QUALIFICATION_CODE.INCOME
          ? `${currency}${range.from} - ${currency}${range.to}`
          : `${range.from} - ${range.to}`,
      ),
    )
    .unwrapOr('');
}
